/*
 * Copyright (c) 2023. Vitalii Kozyr
 */

package tables.domain.interactor

class FormIsNotValidException : Exception(message = "Form is not valid.")